import React from 'react';
import Select from 'react-select';

const UserFilters = ({
  filters,
  dropdowns = {},
  onFilterChange,
  onClearFilters,
  filtersToShow, // optional array of keys to render (e.g., ['cluster', 'chapter', 'startDate', 'endDate'])
}) => {
  const visibleFilters = filtersToShow || ['cluster', 'role', 'responsibility', 'chapter', 'startDate', 'endDate'];

  const clusters = dropdowns.clusters || [];
  const roles = dropdowns.roles || [];
  const responsibilities = dropdowns.responsibilities || [];
  const chapters = dropdowns.chapters || [];

  const handleMultiChange = (key, selectedOptions) => {
    const values = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
    onFilterChange(key, values);
  };

  const handleSingleChange = (key, selectedOption) => {
    const value = selectedOption ? selectedOption.value : '';
    console.log('UserFilters - Single change:', key, '=', value);
    onFilterChange(key, value);
  };

  return (
    <div className="d-flex flex-wrap gap-3 mb-3 align-items-end border p-3 rounded shadow-sm bg-white">
      {visibleFilters.includes('cluster') && (
        <div style={{ minWidth: 180 }}>
          <label className="form-label small mb-1">Cluster</label>
          <Select
            options={clusters}
            value={clusters.find(opt => opt.value === filters.cluster) || null}
            onChange={selected => handleSingleChange('cluster', selected)}
            placeholder="Select Cluster"
            isClearable
            classNamePrefix="react-select"
          />
        </div>
      )}

      {visibleFilters.includes('role') && (
        <div style={{ minWidth: 180 }}>
          <label className="form-label small mb-1">Role</label>
          <Select
            options={roles}
            value={roles.find(opt => opt.value === filters.role) || null}
            onChange={selected => handleSingleChange('role', selected)}
            placeholder="Select Role"
            isClearable
            classNamePrefix="react-select"
          />
        </div>
      )}

      {visibleFilters.includes('responsibility') && (
        <div style={{ minWidth: 200 }}>
          <label className="form-label small mb-1">Responsibility</label>
          <Select
            options={responsibilities}
            value={responsibilities.find(opt => opt.value === filters.responsibility) || null}
            onChange={selected => handleSingleChange('responsibility', selected)}
            placeholder="Select Responsibility"
            isClearable
            classNamePrefix="react-select"
          />
        </div>
      )}

      {visibleFilters.includes('chapter') && (
        <div style={{ minWidth: 180 }}>
          <label className="form-label small mb-1">Chapter</label>
          <Select
            options={chapters}
            value={chapters.find(opt => opt.value === filters.chapter) || null}
            onChange={selected => handleSingleChange('chapter', selected)}
            placeholder="Select Chapter"
            isClearable
            classNamePrefix="react-select"
          />
        </div>
      )}

      {(visibleFilters.includes('startDate') || visibleFilters.includes('endDate')) && (
        <div style={{ minWidth: 280 }}>
          <label className="form-label small mb-1">Date Range</label>
          <div className="d-flex gap-2">
            {visibleFilters.includes('startDate') && (
              <input
                type="date"
                className="form-control form-control-sm"
                value={filters.startDate || ''}
                onChange={e => onFilterChange('startDate', e.target.value)}
                style={{ flex: 1 }}
              />
            )}
            <span className="align-self-center" style={{ fontSize: 13 }}>to</span>
            {visibleFilters.includes('endDate') && (
              <input
                type="date"
                className="form-control form-control-sm"
                value={filters.endDate || ''}
                onChange={e => onFilterChange('endDate', e.target.value)}
                style={{ flex: 1 }}
              />
            )}
          </div>
        </div>
      )}

      <div className="align-self-end">
        <button className="btn btn-sm btn-outline-danger mt-2" onClick={onClearFilters}>
          Clear Filters
        </button>
      </div>
    </div>
  );
};

export default UserFilters;
